import { useUncontrolled } from "@taroify/hooks/index.js";
import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
import RadioGroupContext from "./radio-group.context.js";
function RadioGroup(props) {
    const { className, defaultValue, value: valueProp, disabled, direction = "vertical", size, children, onChange: onChangeProp, ...restProps } = props;
    const { value, setValue } = useUncontrolled({
        value: valueProp,
        defaultValue,
        onChange: onChangeProp,
    });
    return (React.createElement(RadioGroupContext.Provider, { value: {
            value,
            disabled,
            direction,
            size,
            onChange: setValue,
        } },
        React.createElement(View, { className: classNames(prefixClassname("radio-group"), prefixClassname(`radio-group--${direction}`), className), children: children, ...restProps })));
}
export default RadioGroup;
